// client/src/modules/forms/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for Forms module sidebar.
 *
 * The Forms module (P8) is now focused on template administration.
 * Form filling, submissions, and workflows are accessed via host modules
 * (Field Service, Assets, Support, etc.) which don't require P8 access.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/forms' },
  { label: 'Templates', path: '/forms/templates' },
  { label: 'Documents', path: '/forms/documents' },
  { label: 'Fill Form', path: '/forms/fill' },
  { label: 'Submissions', path: '/forms/submissions' },
  { label: 'Org Profile', path: '/forms/org-profile' },
  { label: 'Equipment Data Review', path: '/forms/master-data-review' },
];
